// Import for side effect: configures the pdf.js worker once, app-wide.
import { pdfjs } from "react-pdf";

// Must stay same-origin: for a cross-origin workerSrc pdf.js builds a blob: worker that
// importScripts() it, and the production CSP (script-src 'self' + allowlist) blocks both.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/es5/build/pdf.worker.min.js",
  import.meta.url
).toString();
